import React, { useState } from 'react';
interface IModalCommon {
    handleClose?: any;
    changeStatus: any;
    curStatus: string;
}
const ApprovalStatus: React.FC<IModalCommon> = ({ handleClose, changeStatus, curStatus }) => {
  const [ status, setStatus ] = useState(curStatus);
  const handleRowClick = (stat: string) => {
    setStatus(stat);
  };

  return (
    <div className='audit-add-modal-cont'>
      <div className='audit-add-modal-cont-head'>
        <div className='audit-add-modal-head-cont-change'>
          <div className='audit-add-modal-head-cont-icon'>
            <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'>
              <path d='M8 8V7M8 12.5V11.5M8 17V16M6.8 20H17.2C18.8802 20 19.7202 20 20.362 19.673C20.9265 19.3854 21.3854 18.9265 21.673 18.362C22 17.7202 22 16.8802 22 15.2V8.8C22 7.11984 22 6.27976 21.673 5.63803C21.3854 5.07354 20.9265 4.6146 20.362 4.32698C19.7202 4 18.8802 4 17.2 4H6.8C5.11984 4 4.27976 4 3.63803 4.32698C3.07354 4.6146 2.6146 5.07354 2.32698 5.63803C2 6.27976 2 7.11984 2 8.8V15.2C2 16.8802 2 17.7202 2.32698 18.362C2.6146 18.9265 3.07354 19.3854 3.63803 19.673C4.27976 20 5.11984 20 6.8 20Z' stroke='#4895EF' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'/>
            </svg>
          </div>
          <div className='audit-add-modal-head-cont-supporting'>
            <h1>Change status</h1>
            <p>Select a new ticket status.</p>
          </div>
        </div>
        <div className='audit-add-modal-head-close' onClick={handleClose}>
          <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'>
            <path d='M18 6L6 18M6 6L18 18' stroke='#85888E' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'/>
          </svg>
        </div>
      </div>
      <div className='activity-cont-frame-left-table-feed-row-cont-divider'></div>
      <div className='audit-add-modal-cont-body' style={{ paddingTop: '12px' }}>
        <div className='audit-add-modal-cont-body-frame'>
          <div className='bill-container-fit-screen-content-row-selection'>
            <div className='bill-container-fit-screen-content-row-checkbox' onClick={() => handleRowClick('Pending')}>
              <div className='bill-container-fit-screen-content-row-input'>
                <div className={`bill-container-fit-screen-content-row-input-icon ${status === 'Pending' ? 'selected' : ''}`}>
                  <div className={`bill-container-fit-screen-content-row-input-icon-rnd ${status === 'Pending' ? 'selected' : ''}`}/>
                </div>
              </div>
              <div className='bill-container-fit-screen-content-row-checkbox-text'>
                <p>Pending</p>
              </div>
            </div>
            <div className='bill-container-fit-screen-content-row-checkbox' onClick={() => handleRowClick('Complete')}>
              <div className='bill-container-fit-screen-content-row-input'>
                <div className={`bill-container-fit-screen-content-row-input-icon ${status === 'Complete' ? 'selected' : ''}`}>
                  <div className={`bill-container-fit-screen-content-row-input-icon-rnd ${status === 'Complete' ? 'selected' : ''}`}/>
                </div>
              </div>
              <div className='bill-container-fit-screen-content-row-checkbox-text'>
                <p>Complete</p>
              </div>
            </div>
            <div className='bill-container-fit-screen-content-row-checkbox' onClick={() => handleRowClick('New Results')}>
              <div className='bill-container-fit-screen-content-row-input'>
                <div className={`bill-container-fit-screen-content-row-input-icon ${status === 'New Results' ? 'selected' : ''}`}>
                  <div className={`bill-container-fit-screen-content-row-input-icon-rnd ${status === 'New Results' ? 'selected' : ''}`}/>
                </div>
              </div>
              <div className='bill-container-fit-screen-content-row-checkbox-text'>
                <p>New Results</p>
              </div>
            </div>
            <div className='bill-container-fit-screen-content-row-checkbox' onClick={() => handleRowClick('Reviewed')}>
              <div className='bill-container-fit-screen-content-row-input'>
                <div className={`bill-container-fit-screen-content-row-input-icon ${status === 'Reviewed' ? 'selected' : ''}`}>
                  <div className={`bill-container-fit-screen-content-row-input-icon-rnd ${status === 'Reviewed' ? 'selected' : ''}`}/>
                </div>
              </div>
              <div className='bill-container-fit-screen-content-row-checkbox-text'>
                <p>Reviewed</p>
              </div>
            </div>
            <div className='bill-container-fit-screen-content-row-checkbox' onClick={() => handleRowClick('Approved')}>
              <div className='bill-container-fit-screen-content-row-input'>
                <div className={`bill-container-fit-screen-content-row-input-icon ${status === 'Approved' ? 'selected' : ''}`}>
                  <div className={`bill-container-fit-screen-content-row-input-icon-rnd ${status === 'Approved' ? 'selected' : ''}`}/>
                </div>
              </div>
              <div className='bill-container-fit-screen-content-row-checkbox-text'>
                <p>Approved</p>
              </div>
            </div>
            <div className='bill-container-fit-screen-content-row-checkbox' onClick={() => handleRowClick('Rejected')}>
              <div className='bill-container-fit-screen-content-row-input'>
                <div className={`bill-container-fit-screen-content-row-input-icon ${status === 'Rejected' ? 'selected' : ''}`}>
                  <div className={`bill-container-fit-screen-content-row-input-icon-rnd ${status === 'Rejected' ? 'selected' : ''}`}/>
                </div>
              </div>
              <div className='bill-container-fit-screen-content-row-checkbox-text'>
                <p>Rejected</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='activity-cont-frame-left-table-feed-row-cont-divider'></div>
      <div className='audit-modal-cont-footer'>
        <div className='audit-modal-cont-footer-content'>
          <div className='audit-modal-cont-footer-content-btn-cancel' onClick={handleClose}>
            <div className='audit-modal-cont-footer-content-btn-text'>
                Cancel
            </div>
          </div>
          <div className='audit-modal-cont-footer-content-btn-upload' onClick={() => {
            changeStatus(status);
            handleClose();
          }}>
            <div className='audit-modal-cont-footer-content-btn-text'>
                Save
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ApprovalStatus;
